<template>
  <review-card
    :key="`list-group-olig-${expanded}`"
    title="Oligoelementos"
    :explanation="explanation"
  >
    <v-list-group
      v-for="(item, index) in oligoelements"
      :key="index"
      class="item-par"
      :value="expanded"
    >
      <template v-slot:activator>
        <v-list-item-title>
          {{ item.oligoelement.name }}
        </v-list-item-title>
      </template>
      <div class="py-3 grey--text text--darken-3">
        <property-value
          property="Informações"
          :value="item.oligoelement.information"
        />
        <property-value
          property="Explicação"
          :value="item.oligoelement.explanation"
        />
        <property-value
          v-show="!!item.oligoelement.dailyIntake"
          property="Ingestão diária"
          :value="item.oligoelement.dailyIntake"
        />
        <property-value
          property="Fontes alimentares recomendadas"
          :value="item.sources | arrayToString"
        />
        <property-value property="Comentários" :value="item.patientComments" />
      </div>
    </v-list-group>
  </review-card>
</template>

<script>
export default {
  name: "ReviewTherapyOligoelements",
  props: {
    oligoelements: {
      type: Array,
      default: () => [],
    },
    explanation: {
      type: String,
      default: "",
    },
    expanded: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped></style>
